import ChantierFormController from './chantier.form.controller';

export default {
    bindings: {
        idChantier: '='
    },
    template: require('./chantier.form.html'),
    controller: ChantierFormController
};
